<template>
    <div class="home-page">
		<Header></Header>
		<div class="home-content">
      <div class="content crfff ac por">
        <div class=" disflex" style="justify-content: space-around;">
          <div class="blcok2-font" @click="getToNav('spin')">
            <div class="por" style="display: inline-block;">
              <img src="../../static/images/ic2.png">
              <span class="yuan" v-if="info.spin_num>0"></span>
            </div>
            <div class="font" style="width: 120px;line-height: 32px;">
            {{$t('SpinWheel')}}
            </div>
          </div>
          <div class="blcok2-font font-left">
            <div class="h-rank">
              <div class="h-rank-div" @click="getToNav('rankList')">
                <img src="../../static/images/ic1.png">
                <span class="font fw7">{{$t('Ranking')}}</span>
              </div>
            </div>
            <div @click="getToNav('myAccount')">
              <img class="por mt30 account-img" style="width: 155px;height: 155px;border-radius: 100%" :src="info.avatar" />
              <div class="font-account">
                <div class="fw7" style="font-size: 40px;">{{info.nickname}}</div>
                <p><img src="../../static/images/ic4.png">{{info.level_name}}</p>
              </div>
            </div>
          </div>
          <div class="blcok2-font font-right" @click="openDailyDialog()">
            <div class="por" style="display: inline-block;">
              <img src="../../static/images/ic3.png">
              <span class="yuan" v-if="!info.is_sign"></span>
            </div>

            <div class="font">
              <div class="" style="width: 130px;line-height: 32px;">{{$t('DaysLogin')}}</div>
            </div>
          </div>
        </div>
        <div class="home-block1 por " @click="getToNav('DailyChallenge')">
            <div class="yuan yuan2" v-if="info.daily_challenge_num">{{info.daily_challenge_num}}</div>
          <div class="disflex" style="padding: 20px 0 0;">
            <div class="disflex">
              <img src="../../static/images/home-img1.png">
              <div class="block2-font">
                <div class="fw7">{{$t('Daily')}}</div>
                <div class="">{{$t('Challenge')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>{{$t('daily_challenge')}}{{info.daily_challenge_num}}</div>

        <div class="disflex mt10" style="justify-content: center;">
          <div class="home-block disflex" style="justify-content: center;" @click="goBattleRoom('rankingChallenge')">
            <div class="home-block2 disflex" style="justify-content: center;">
              <div class="por">
                <div class="yuan yuan2" style="top:-20px" v-if="info.game_num">{{info.game_num}}</div>
                <img src="../../static/images/home-img2.png">
                <div class="block2-font">
                  <div class="font">{{$t('RankingChallenge')}}</div>
                </div>
              </div>
            </div>
            <div class="home-block3 disflex" @click="goBattleRoom('friend')">
              <div class="por">
                <div class="yuan yuan2" style="top:-20px" v-if="info.game_num">{{info.game_num}}</div>
                <img src="../../static/images/home-img3.png">
                <div class="block2-font">
                  <div class="font">{{$t('FriendChallenge')}}</div>
                </div>
              </div>
            </div>
            <div class="home-block4 disflex" @click="goBattleRoom('fast')">
              <div class="por">
                <div class="yuan yuan2" style="top:-20px" v-if="info.game_num">{{info.game_num}}</div>
                <img src="../../static/images/home-img4.png">
                <div class="block2-font">
                  <div class="font">{{$t('FastChallenge')}}:</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>{{$t('share_challenge')}}{{info.game_num}}</div>
        <div v-if="game_time || game_bonus.left_second || game_free" class="game_props" style="background-color: #440DB1">
          <div>
            <div v-if="game_time" class="disflex"><div class="l">{{$t('Game_Time')}} : </div><div><img src="../../static/images/free_time.png"> {{ formatTime(game_time) }}</div></div>
            <div v-if="game_bonus.left_second" class="disflex" style="margin-top: 5px"><div class="l">{{$t('Game_Bonus')}} : </div><div><img src="../../static/images/free_bonus.png"> {{ formatTime(game_bonus.left_second) }}</div></div>
            <div v-if="game_free" class="disflex" style="margin-top: 5px"><div class="l">{{$t('Game_Free')}} : </div><div><img src="../../static/images/free_chance.png"> {{game_free}} {{$t('Chances')}}</div></div>
          </div>
        </div>
        <div class="ac mt30">
          <button class="btn bg-yellow" @click="openInvitationModal"><span>{{$t('InviteFriends')}} ></span></button>
        </div>
      </div>
      <div class="home-bottom disflex">
        <div class="bt-icon1" @click="getToNav('book')">
          <img src="../../static/images/mb-ic1.png">
          <span class="">{{$t('books')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('bank')">
          <img src="../../static/images/mb-ic2.png">
          <span class="">{{$t('bank')}}</span>
        </div>
        <div class="bt-icon1 bt-icon2 active_1" @click="getToNav('')">
          <img style="margin-top: -70px;" src="../../static/images/mb-ic3-h.png">
          <span class="">{{$t('home')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('shop')">
          <img src="../../static/images/mb-ic4.png">
          <span class="">{{$t('shop')}}</span>
        </div>
        <div class="bt-icon1" @click="getToNav('language')">
          <img src="../../static/images/mb-ic5.png">
          <span class="">{{$t('Settings')}}</span>
        </div>
      </div>
		</div>
      <div class="modal defModal" v-if="isChooseShow">
        <div class="modal-bg"></div>
        <div class="modal-content choose-modal-content">
          <div class="title">{{$t('ChooseTitle')}}</div>
          <div class="choose-list">
            <div class="choose-li" :class="{'active':isSelect==item.id}" v-for="(item,index) in chooseList" @click="clickSelect(item.id)">
              <div class="disflex"><img class="choose-img" :src="item.image" /></div>
              <span><span class="dian"></span>{{item.name}}</span>
            </div>
          </div>
          <div class="">
            <button class="btn btn-blue" @click="getChooseNav()">{{$t('Save')}}</button>
            <button class="btn btn-none mt20" @click="chooseCancel">{{$t('Back')}}</button>
          </div>
        </div>
      </div>

      <Dialog ref="dailyDialog" type="alert" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal daily-modal2 por">
              <DailyLogin @child-event="handleChildData" message="1"></DailyLogin>
            </div>
              <div class="mt30" @click="closeDailyModal"><img src="../../static/images/close.png"></div>
          </div>
      </Dialog>
      <Dialog ref="InvitationDialog" type="alert" title="" width="100" :modalFoot="false">
          <div class="" slot="mdBox" >
            <div class="answer-modal invitation-dialog por">
              <div class="close ar" @click="closeInvitationModal"><img src="../../static/images/close.png"></div>
              	<div class="">
                  <div class="fs50 mt20 ac">{{$t('invitation')}}</div>
                  <div class="ac mt50">
                  </div>
                  <div class="fs33 mt20 ac">{{$t('invitationTips')}}</div>
                  <div class="ac mt30">
                    <img src="../../static/images/Coins.png">
                  </div>
                  <div class="disflex">
                    <div class="input-item mt30">
                      <div class="input-item2">
                        <input class="input" v-model="invite_url" disabled type="" placeholder="">
                        <button style="width: 40%;" class="button btn-green fw7" id="copycode" :data-clipboard-text="invite_url" @click="copy(invite_url)"><span>{{$t('copy')}}</span></button>
                      </div>
                    </div>
                  </div>
              	</div>
            </div>
          </div>
      </Dialog>
      <Dialog ref="otpDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="" slot="mdBox">
            <div class="otp-title" v-if="buyTitleType === 'buy'">{{$t('BuyChances')}}</div>
            <div class="otp-title" v-else-if="buyTitleType === 'enough'">{{$t('ChanceEnough')}}</div>
              <div class="otp-modal disflex ac">
                <div class="">
                  <img width="280" src="../../static/images/buy-img.png">
                  <div class="otp-font">
                    {{$t('BuyChancesC')}}
                  </div>
                 <!-- <div class="input-div">
                   <div class="span fs33 crfff app-en fw7" style="margin:50px 0 20px;">OTP</div>
                   <div class="input-item" style="background: none;">
                     <div class="input-item2 disflex">
                       <input class="input-item input" v-model="otp" ref="getFocus2" maxlength="4" type="number" style="width: 100%;height:80px;" placeholder="">
                       <button class="btn btn-red" style="padding: 0 10px;min-height: 80px;line-height: 80px;min-width: 160px;margin-left:5px;font-size: 30px;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
                     </div>
                   </div>
                 </div> -->
                  <div class="mt10 disflex">
                    <button class="btn btn-none" style="border: 2px solid #fff;color:#fff;width: auto;min-width: 250px;" @click="cancelOtpDialog"><span>{{$t('Later')}}</span></button><!-- :class="{'none':otp==''}" -->
                    <button class="btn btn-blue" style="width: auto;min-width: 250px;" @click="getSubmit"><span style="padding: 10px;">{{$t('BuyMore')}}</span></button><!-- :class="{'none':otp==''}" -->
                  </div>
                </div>
              </div>
          </div>
      </Dialog>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import DailyLogin from '../components/dailyLogin'
import Invitation from '../components/invitation'
import ClipboardJS from 'clipboard';
export default {
    components:{
		Header,Dialog,DailyLogin,Invitation
    },
    data() {
      return {
        isShow:null,
        isEN:'bur',
        mobile:'',
         otp:'',
         codeText:'',
         isReturn:false,
         chooseList:[
           'Movies','Musics','Countries','Sports'
         ],
         isSelect:false,
         isChooseShow:false,
         info:{},
         buyTitleType: 'buy', // 或 'enough'
         invite_url:'',
        //游戏道具
        game_time:0,
        game_bonus:{left_second:0,add_rate:0},
        game_free:0,
      }
    },
	created(){
    this.isEN = localStorage.getItem('lang')
    this.codeText = this.$t('getCode');
    this.getHome();
	},
    methods: {
      copy(item) {
        const fakeButton = document.createElement('button');
        fakeButton.style.display = 'none';
        fakeButton.setAttribute('data-clipboard-text', item);
        document.body.appendChild(fakeButton);
        const clipboard = new ClipboardJS(fakeButton);
        clipboard.on('success', (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'));
          clipboard.destroy();
          document.body.removeChild(fakeButton);
        });

        clipboard.on('error', (e) => {
          clipboard.destroy();
          document.body.removeChild(fakeButton);
        });

        // Trigger the click programmatically
        fakeButton.click();
      },
      handleChildData(){
        this.getHome();
      },
      goBattleRoom(url){
         if (this.info.game_num <1){
           //判断是否有游戏道具
           if (this.game_time  <= 0 && this.game_free <= 0 ){
             let that =this;
             that.buyTitleType = "enough"
             that.$refs.otpDialog.showMaskFun();
             return;
           }
         }
        this.$router.push({path:'/'+url});
      },
      getToNav(url){
        this.$router.push({path:'/'+url});
      },
      clickSelect(item){
        this.isSelect = item
      },
      getChooseNav(){
        let that = this
        that.$parent.loadModal(true);
        let data = {
          "question_type_id":that.isSelect
        }
        that.$api.post('/api/index/select_question_type',data,r =>{
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80);
          that.isChooseShow = false
          return;
        })
      },
      chooseCancel(){
        this.isChooseShow = false
      },
      openDailyDialog(){
        this.$refs.dailyDialog.showMaskFun()
      },
      closeDailyModal(){
        this.$refs.dailyDialog.closeMask()
      },
      closeInvitationModal(){
        this.$refs.InvitationDialog.closeMask()
      },
      openInvitationModal(){
        this.$refs.InvitationDialog.showMaskFun()
      },
      getHome(){
        this.getUserInfo();
        this.getQuestionType();
        this.getProps();
      },
      getUserInfo(){
        let that =this;
        that.$api.get('/api/user/info',null,r =>{
          that.$parent.returnCode(r,function(){
            that.info = r.data
            that.invite_url = r.data.invite_url
            if(!r.data.is_sign){
              that.$refs.dailyDialog.showMaskFun();
            }
          });
        })
      },
      getQuestionType(){
        let that =this;
        that.$api.get('/api/index/question_type',null,r =>{
          that.$parent.returnCode(r,function(){
            that.chooseList=r.data.question_type
            that.isSelect=r.data.user_type_id
          });
        })
      },
      cancelOtpDialog(){
        this.$refs.otpDialog.closeMask();
      },
      getSubmit(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/index/buy',null,r =>{
        	that.$parent.returnCode(r,function(){
        		that.$parent.loadModal(false);
            if (r.code == 1){
              that.$refs.otpDialog.closeMask();
              that.$utils.alertText(r.msg,80, 800);
              that.getUserInfo();
            }else{
              that.$utils.alertText(r.msg,80, 3000);
            }
        	});
        })
      },
      getSub(type){
        let that =this;
        that.buyTitleType = "buy"
        that.$refs.otpDialog.showMaskFun();
      },
      getProps(){
        let that = this
        that.$api.post('/api/user/game_props',null,r =>{
          that.$parent.returnCode(r,function(){
            if (r.code == 1){
                that.game_time = r.data.game_time
                if (that.game_time >0 ){
                  that.gameTimeCountDown(that.game_time)
                }
                that.game_bonus = r.data.game_bonus
                if (that.game_bonus.left_second  >0 ){
                  that.gameBonusCountDown(that.game_bonus.left_second)
                }
                that.game_free = r.data.game_free
            }
          });
        })
      },
      formatTime(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const min = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const sec = (seconds % 60).toString().padStart(2, '0');

        if (hrs > 0) {
          return `${hrs.toString().padStart(2, '0')}:${min}:${sec}`;
        } else {
          return `${min}:${sec}`;
        }
      },
      gameTimeCountDown (miao,type){
        if(miao === 0){
          this.game_time = 0;
          return;
        }
        miao--;
        this.game_time = miao;
        setTimeout(() =>{
          this.gameTimeCountDown(miao,type);
        },1000)
      },
      gameBonusCountDown (miao,type){
        if(miao === 0){
          this.game_bonus.left_second = 0;
          return;
        }
        miao--;
        this.game_bonus.left_second = miao;
        setTimeout(() =>{
          this.gameBonusCountDown(miao,type);
        },1000)
      }

	}
}
</script>
<style scoped>
  .choose-modal-content{position: absolute;
      top: auto;
      bottom: 0;
      transform: translate(0, 0);
      background: #f6f6f6;
      width: 100%;
      left: 0;
      min-height: 600px;padding:40px}
    .choose-modal-content .title{color:#4c5bff;text-align: center;margin-bottom: 20px;font-size: 36px}
    .choose-list{padding:20px 0 40px}
    .dian{    position: absolute;
    right: 10px;
    top: 10px;}
    .active .dian{background: url(../../static/images/gou.png) no-repeat 0 0;width: 36px;height: 36px;background-size:cover;border: none;}
    .choose-li{padding:20px 0}
  .close{
    background: rgb(255 255 255 / 40%);
    color: #fff;
    width: 80px;
    height: 80px;
    line-height: 80px;
    font-size: 60px;
    border-radius: 100px;
        position: absolute;
        right: -20px;
        top: -20px;
        margin: 0;
  }
  .new-img{margin: 40px 40px 0;width: auto;}
  .new-img .img-b{width: 48%;border: 4px solid #0062ff;
    border-radius: 10px;}
  .img-b img{width: 100%;border-radius: 10px;}
  .game_props{
    border: 4px solid #fff;
    border-radius: 10px;
    width: 80%;
    margin: 0 auto;
    text-align: left;
    display: flex;
    justify-content: center;
    padding: 20px 10px;
  }
  .game_props >div{width: 100%}
  .game_props .disflex .l{width: 50%;text-align: right;margin-right: 10px}
</style>



// WEBPACK FOOTER //
// src/page/index.vue